/* istanbul ignore file */
import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import classNames from 'classnames';

import UserContext from '@context/User/user-context';
import SavedIconSvg from '@components/shared/buttons/SaveButton/OverlayIconSvg';
import ButtonSvgIcon from '@components/shared/buttons/svg-icon/ButtonSvgIcon';
import UNSAVE_VENDOR_VARIANT from '@graphql/VendorVariant/mutations/unsave-vendor-variant';
import useAlert, { TYPES } from '@hooks/useAlert/useAlert';

import analyticsTrack from '@lib/analytics/analyticsTrack';
import styles from './SavedBadge.module.scss';

interface ISavedBadgeProps {
  vendorVariantId: number;
  sourceBoardId?: number;
  pageSource?: string;
  className?: string;
}

const SavedBadge = ({
  className,
  vendorVariantId,
  sourceBoardId,
  pageSource,
}: ISavedBadgeProps) => {
  const {
    removeSavedForLaterVendorVariants,
    savedForLaterVendorVariants
  } = useContext(UserContext);
  const [unsaveVendorVariant] = useMutation(UNSAVE_VENDOR_VARIANT);
  const errorAlert = useAlert(TYPES.ERROR);
  const successAlert = useAlert(TYPES.SHOP_SUCCESS);

  if (!savedForLaterVendorVariants[vendorVariantId]) {
    return null;
  }

  const handleUnsaveForLater = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    analyticsTrack('unsaved_for_later', {
      vendorVariantId,
      boardId: sourceBoardId,
      source: pageSource
    });

    try {
      await unsaveVendorVariant({
        variables: {
          vendorVariantId,
        },
      });
    } catch (e) {
      errorAlert(`Failed to unsave for later.`);
      return;
    }

    successAlert('Unsaved for later!');
    removeSavedForLaterVendorVariants(vendorVariantId);
  };

  return (
    <ButtonSvgIcon
      classNames={classNames(className, styles.Saved)}
      onClick={ handleUnsaveForLater }
    >
      <SavedIconSvg />
    </ButtonSvgIcon>

  );
};

export default SavedBadge;
